import React, { useRef } from 'react';
import classes from './gallery.module.css';

export default function Gallery({ images }) {
    const galleryRef = useRef(null);

    const scrollLeft = () => {
        galleryRef.current.scrollBy({
            top: 0,
            left: -galleryRef.current.clientWidth, // Scroll by the width of the visible area
            behavior: 'smooth'
        });
    };

    const scrollRight = () => {
        galleryRef.current.scrollBy({
            top: 0,
            left: galleryRef.current.clientWidth,
            behavior: 'smooth'
        });
    };

    return (
        <div className={classes.GalleryBackground}>
            <div className={classes.GalleryContainer}>
                <button className={classes.GalleryButton} onClick={scrollLeft}>
                    <span className={[classes.ArrowContainer, classes.Left].join(" ")}>
                        <span className={classes.Arrow} /><span className={classes.Arrow} />
                    </span>
                </button>
                <div className={classes.Gallery} ref={galleryRef}>
                    {images.map((image, index) => (
                        <img key={index} src={image?.image ? image.image : image.image_path ? image.image_path : image}
                            alt={image?.caption ? image.caption : `Gallery ${index}`} className={classes.GalleryImage} />
                    ))}
                </div>
                <button className={classes.GalleryButton} onClick={scrollRight}>
                    <span className={[classes.ArrowContainer, classes.Right].join(" ")}>
                        <span className={classes.Arrow} /><span className={classes.Arrow} />
                    </span>
                </button>
            </div>
        </div>
    );
}